/**
 * @file: product.service.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { HttpClient } from '@euler/lib/request';
import { IdType } from '@euler/model/common';
import {
  ProductSearchParams,
  ProductWithContractId,
  ProductWithDetail,
} from '@euler/model/product';

export class ProductService {
  constructor(private readonly api: HttpClient) {}

  async hasProducts(): Promise<boolean> {
    return await this.api.get().url('/products/has-any').future();
  }

  async searchProducts(
    params: ProductSearchParams | undefined,
    offset: number,
    limit: number,
  ): Promise<ProductWithContractId[]> {
    return await this.api
      .get()
      .url('/products/search', {
        keyword: params?.keyword,
        brand_id: params?.brandId,
        offset,
        limit,
      })
      .future();
  }

  async getProductDetail(productId: IdType): Promise<ProductWithDetail> {
    return await this.api
      .get()
      .url('/products/:productId/detail', { productId })
      .future();
  }
}
